import { render, staticRenderFns } from "./dashboard_designer.vue?vue&type=template&id=0c640e31"
import script from "./dashboard_designer.vue?vue&type=script&lang=js"
export * from "./dashboard_designer.vue?vue&type=script&lang=js"
import style0 from "./dashboard_designer.vue?vue&type=style&index=0&id=0c640e31&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports